const LauncherIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='30'
      height='24'
      viewBox='0 0 30 24'
      fill='none'
    >
      <path
        d='M12.6062 5.49035L13.0238 7.44411C13.4024 9.21462 14.7854 10.5976 16.5559 10.9762L18.5096 11.3938C19.1635 11.5336 19.1635 12.4664 18.5096 12.6062L16.5559 13.0238C14.7854 13.4024 13.4024 14.7854 13.0238 16.5559L12.6062 18.5096C12.4664 19.1635 11.5336 19.1635 11.3938 18.5096L10.9762 16.5559C10.5976 14.7854 9.21462 13.4024 7.44411 13.0238L5.49035 12.6062C4.83655 12.4664 4.83655 11.5336 5.49035 11.3938L7.44411 10.9762C9.21462 10.5976 10.5976 9.21462 10.9762 7.44411L11.3938 5.49035C11.533 4.83655 12.4664 4.83655 12.6062 5.49035Z'
        fill='#5B31AA'
      />
      <path
        d='M28.9483 14.6332L21.8352 22H16L25.6575 11.998L16.0038 2H21.839L28.9483 9.36287C30.3506 10.819 30.3506 13.177 28.9483 14.6332Z'
        fill='#FD8100'
      />
    </svg>
  );
};

export default LauncherIcon;
